import API from "@/interceptors/Api";
import type { AssignRoleRequest, CashPoolingUserRole } from "../types/role.types";

export const assignRole = async (request: AssignRoleRequest): Promise<CashPoolingUserRole> => {
  const response = await API.put("/cash-pooling/roles", request);
  return response as unknown as CashPoolingUserRole;
};
